/**
 * What XAir actually charges this school, in words.
 *
 * "XAir takes a 15% fee either way" was hardcoded in three places across two
 * screens. It is false for a school on a platform contract — which is the
 * entire US model — so a US owner's first login contradicted the pitch they
 * signed. One helper, so a fourth place cannot be written from memory.
 *
 * Takes tutorsConfig (which carries platformContract and marketplaceCommissionRate).
 */
export function platformFee(config) {
  const onContract = Boolean(config?.platformContract?.active);
  if (onContract) {
    return {
      applies: false,
      pct: 0,
      label: "No per-booking fee",
      tile: "Included in your contract",
      sentence: "You are on a platform contract, so there is no per-booking fee.",
    };
  }
  const rate = config?.marketplaceCommissionRate;
  const pct = typeof rate === "number" ? Math.round(rate * 100) : null;
  return {
    applies: true,
    pct,
    label: pct === null ? "XAir's platform fee" : `XAir takes a ${pct}% fee`,
    tile: "XAir's platform fee",
    sentence: pct === null
      ? "XAir's platform fee applies to every booking."
      : `XAir's ${pct}% fee applies to every booking.`,
  };
}

export default platformFee;
